import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index.js'
// 导入一级路由
import Index from '@/views/index'
import login from '@/views/login/login.vue'
import forget from '@/views/login/forget.vue'
import Register from '@/views/Register/Register.vue'
import registerEmail from '@/views/Register/registerEmail.vue'
import allsearchRefine from '@/views/allsearchRefine/allsearchRefine.vue'
Vue.use(VueRouter)
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return routerPush.call(this, location).catch(error => error)
}

const routes = [
	
	{
		path: '/',
		redirect: '/index'
	},
	{
		path: '/index',
		name: 'index',
		component: Index,
		meta: {
			title: '首页'
		}
	},
	{
		path: '/login',
		name: 'login',
		component: login,
		meta: {
			nofoot: true
		}
	},
	{
		path: '/register',
		name: 'register',
		component: Register,
		meta: {
			nofoot: true
		}
	},
	{
		path: '/registerEmail',
		name: 'registerEmail',
		component: registerEmail,
		meta: {
			nofoot: true
		}
	},
	{
		path: '/forget',
		name: 'forget',
		component: forget,
		meta: {
			nofoot: true
		}
	},
	{
		path: '/editor',
		name: 'editor',
		component: () => import('../views/editor/editor.vue'),
		meta: {
			type:'keep',
			nohead: true,
			editor:true
		}
	},
	{
		path: '/editorbanben',
		name: 'editorbanben',
		component: () => import('../views/editor/editorbanben.vue'),
		meta: {
			type:'keep',
			nohead: true,
			editor:true
		}
	},
	{
		path: '/editorbanben1',
		name: 'editorbanben1',
		component: () => import('../views/editor/editorbanben1.vue'),
		meta: {
			type:'keep',
			nohead: true,
			editor:true
		}
	},
	{
		path: '/kongEditor',
		name: 'kongEditor',
		component: () => import('../views/editor/kongEditor.vue'),
		meta: {
			type:'keep',
			nohead: true,
			editor:true
		}
	},
	{
		path: '/kongEditor1',
		name: 'kongEditor1',
		component: () => import('../views/editor/kongEditor1.vue'),
		meta: {
			type:'keep',
			nohead: true,
			editor:true
		}
	},
	{
		path: '/histroyEditor',
		name: 'histroyEditor',
		component: () => import('../views/editor/histroyEditor.vue'),
		meta: {
			type:'keep',
			nohead: true,
			editor:true
		}
	},
	{
		path: '/allsearchRefine',
		component: allsearchRefine,
		children: [{
				path: '/',
				component: () => import('../views/allsearchRefine/allsearch.vue'),
				meta: {
					title: '总搜索与精炼'
				}
			},
			{
				path: 'xmxqC',
				component: () => import('../views/allsearchRefine/xmxqC.vue'),
				meta: {
					title: '项目需求池',
					type:1
				}
			},

		]
	},
	{
		path: '/projectNeed',
		name: 'projectNeed',
		component: () => import('../views/ProjectNeed/ProjectNeed.vue'),
		meta: {
			title: '项目需求',
			type:1,
		},
		children: [{
				path: 'releaseNeed',
				name:'releaseNeed',
				component: () => import('../views/ProjectNeed/releaseNeed.vue'),
				meta: {
					title: '项目需求发布',
					type:1,
					keepAlive: true
				}
			}, {
				path: 'jiaFangDJ',
				name: 'jiaFangDJ',
				component: () => import('../views/ProjectNeed/jiaFangDJ.vue'),
				meta: {
					title: '甲方项目登记',
					type:1
				}
			},
			{
				path: 'yiFangDj',
				component: () => import('../views/ProjectNeed/yiFangDj.vue'),
				meta: {
					title: '乙方项目登记',
					type:1
				}
			},
			{
				path: 'KTDW',
				component: () => import('../views/ProjectNeed/KTDW.vue'),
				meta: {
					title: '课题定位',
					type:1,
					keepAlive: true
				}
			},
			{
				path: 'projectGoHelp',
				component: () => import('../views/ProjectNeed/projectGoHelp.vue'),
				meta: {
					title: '应助',
					type:1
				}
			},
			{
				path: 'editDraft',
				name:'editDraft',
				component: () => import('../views/ProjectNeed/editDraft.vue'),
				meta: {
					title: '草稿详情',
					type:1,
					keepAlive: true
				}
			},
			{
				path: 'editbanben',
				name:'editbanben',
				component: () => import('../views/ProjectNeed/editbanben.vue'),
				meta: {
					title: '编辑版本',
					type:1,
					keepAlive: true
				}
			},
		]
	},
	{
		path: '/ktdwDetail',
		name: 'ktdwDetail',
		component: () => import('../views/ProjectNeed/ktdwDetail.vue'),
		meta: {
			type:1
		}
	},
	{
		path: '/ktdwzjDetail',
		name: 'ktdwzjDetail',
		component: () => import('../views/ProjectNeed/ktdwzjDetail.vue'),
		meta: {
			type:1
		}
	},
	{
		path: '/projectNeedDetail',
		name: 'projectNeedDetail',
		component: () => import('../views/ProjectNeed/projectNeedDetail.vue'),
		meta: {
			type:1
		}
	},
	{
		path: '/ResourceTools',
		component: () => import('../views/ResourceTools/index.vue'),
		meta: {
			title: '资源工具',
			type:2,
			editor:false
		},
		children: [{
				path: '/',
				component: () => import('../views/ResourceTools/XMtools.vue'),
				meta: {
					title: '资源工具池',
					type:2
				}
			},
			{
				path: 'helpList',
				component: () => import('../views/ResourceTools/helpList.vue'),
				meta: {
					title: '求助列表',
					type:2
				}
			},

		]
	},
	{
		path: '/zyTools',
		component: () => import('../views/ResourceTools/ZyTools.vue'),
		meta: {
			title: '资源工具详情',
			type:2
		},
		children: [{
				path: '/',
				component: () => import('../views/ResourceTools/ZyToolsDetail.vue'),
				meta: {
					title: '资源工具详情',
					type:2
				}
			}, {
				path: 'zyQiuzDetail',
				component: () => import('../views/ResourceTools/zyQiuzDetail.vue'),
				meta: {
					title: '资源工具求助详情',
					type:2
				}
			},
			{
				path: 'partyBPage',
				component: () => import('../views/ResourceTools/partyBPage.vue'),
				meta: {
					title: '资源工具乙方',
					type:2
				}
			},
			{
				path: 'jf',
				component: () => import('../views/ResourceTools/JF.vue'),
				meta: {
					title: '甲方页面',
					type:2
				}
			},
			{
				path: 'createTools',
				component: () => import('../views/ResourceTools/createTools.vue'),
				meta: {
					title: '创建资源工具',
					type:2,
					keepAlive: true
				}
			},
			{
				path: 'createQZtools',
				component: () => import('../views/ResourceTools/createQZtools.vue'),
				meta: {
					title: '创建资源工具求助',
					type:2,
					keepAlive: true
				}
			},
			{
				path: 'seekHelpDrafts',
				component: () => import('../views/ResourceTools/seekHelpDrafts.vue'),
				meta: {
					title: '资源工具求助草稿',
					type:2,
					keepAlive: true
				}
			},
			{
				path: 'YZneed',
				component: () => import('../views/ResourceTools/YZneed.vue'),
				meta: {
					title: '应助需求',
					type:2,
					keepAlive: true
				}
			},
			{
				path: 'YzNeedDraft',
				component: () => import('../views/ResourceTools/YzNeedDraft.vue'),
				meta: {
					title: '应助需求草稿',
					type:2,
					keepAlive: true
				}
			},
			{
				path: 'editDraft',
				component: () => import('../views/ResourceTools/editDraft.vue'),
				meta: {
					title: '修改草稿',
					type:2,
					keepAlive: true
				}
			},
		]
	},
	{
		path: '/searchIndex',
		name: 'searchIndex',
		component: () => import('../views/search/searchIndex.vue'),
		meta: {
			title: '总搜索'
		},
		children: [{
				path: 'Solution',
				component: () => import('../views/Solution/Solution.vue'),
				meta: {
					title: '解决方案池',
					type:3
				}
			}, {
				path: 'solutionHelpList',
				component: () => import('../views/Solution/solutionHelpList.vue'),
				meta: {
					title: '解决方案池求助列表',
					type:3
				}
			},
		]
	},
	{
		path: '/proIndex',
		name: 'proIndex',
		component: () => import('../views/productService/proIndex.vue'),
		meta: {
			title: '产品服务'
		},
		children: [
			{
				path: 'productService',
				component: () => import('../views/productService/productService.vue'),
				meta: {
					title: '产品服务池',
					type:4
				}
			},
			{
				path: 'proHelpList',
				component: () => import('../views/productService/proHelpList.vue'),
				meta: {
					title: '产品服务池求助列表',
					type:4
				}
			},
		]
	},
	{
		path: '/solutionDetail',
		component: () => import('../views/Solution/solutionDetail.vue'),
		meta: {
			title: '方案池详情',
			type:3
		},
		children: [{
				path: '/',
				component: () => import('../views/Solution/detailSon.vue'),
				meta: {
					title: '解决方案详情',
					type:3
				}
			},
			{
				path: 'buyFullversion',
				component: () => import('../views/Solution/buyFullversion.vue'),
				meta: {
					title: '购买完整版',
					type:3
				}
			},
			{
				path: 'partyBPage',
				component: () => import('../views/Solution/partyBPage.vue'),
				meta: {
					title: '资源工具乙方',
					type:3
				}
			},
			{
				path: 'FAQ',
				component: () => import('../views/Solution/FAQ.vue'),
				meta: {
					title: '常见问题',
					type:3
				}
			},
			{
				path: 'QZdetail',
				component: () => import('../views/Solution/QZdetail.vue'),
				meta: {
					title: '求助详情',
					type:3
				}
			},
			{
				path: 'QZJFBJ',
				component: () => import('../views/Solution/QZJFBJ.vue'),
				meta: {
					title: '求助详情甲方编辑页',
					type:3
				}
			},
			{
				path: 'solutionYzNeed',
				component: () => import('../views/Solution/solutionYzNeed.vue'),
				meta: {
					title: '解决方案应助需求',
					type:3,
					keepAlive: true
				}
			},
			{
				path: 'YzNeedDrafts',
				component: () => import('../views/Solution/YzNeedDrafts.vue'),
				meta: {
					title: '解决方案应助需求',
					type:3,
					keepAlive: true
				}
			},
			{
				path: 'editDraft',
				component: () => import('../views/Solution/editDraft.vue'),
				meta: {
					title: '创建解决方案草稿',
					type:3,
					keepAlive: true
				}
			},
			{
				path: 'releaseSolution',
				component: () => import('../views/Solution/releaseSolution.vue'),
				meta: {
					title: '创建解决方案',
					type:3,
					keepAlive: true
				}
			},
			{
				path: 'createQz',
				component: () => import('../views/Solution/createQz.vue'),
				meta: {
					title: '创建求助',
					type:3,
					keepAlive: true
				}
			},
			{
				path: 'seekHelpDrafts',
				component: () => import('../views/Solution/seekHelpDrafts.vue'),
				meta: {
					title: '求助草稿',
					type:3,
					keepAlive: true
				}
			},
			{
				path: 'qZJFdetail',
				component: () => import('../views/Solution/qZJFdetail.vue'),
				meta: {
					title: '求助详情甲方',
					type:3
				}
			},
		]
	},
	{
		path: '/productService',
		component: () => import('../views/productService/productIndex.vue'),
		meta: {
			title: '产品服务池',
			type:4
		},
		children: [{
				path: '/',
				component: () => import('../views/productService/productDetail.vue'),
				meta: {
					title: '求助详情',
					type:4
				}
			},
			{
				path: 'proCreateQz',
				component: () => import('../views/productService/proCreateQz.vue'),
				meta: {
					title: '创建产品服务求助',
					type:4,
					keepAlive: true
				}
			},
			{
				path: 'seekHelpDrafts',
				component: () => import('../views/productService/seekHelpDrafts.vue'),
				meta: {
					title: '创建产品服务求助',
					type:4,
					keepAlive: true
				}
			},
			{
				path: 'partyBPage',
				component: () => import('../views/productService/partyBPage.vue'),
				meta: {
					title: '产品服务求助乙方',
					type:4,
					keepAlive: true
				}
			},
			{
				path: 'buyFullV',
				component: () => import('../views/productService/buyFullV.vue'),
				meta: {
					title: '购买产品服务',
					type:4
				}
			},
			{
				path: 'productQZdetail',
				component: () => import('../views/productService/productQZdetail.vue'),
				meta: {
					title: '产品求助详情',
					type:4
				}
			},
			{
				path: 'productJFQZdetail',
				component: () => import('../views/productService/productJFQZdetail.vue'),
				meta: {
					title: '产品甲方详情',
					type:4
				}
			},
			{
				path: 'productJFBJ',
				component: () => import('../views/productService/productJFBJ.vue'),
				meta: {
					title: '产品甲方编辑页',
					type:4
				}
			},
			{
				path: 'createProductService',
				component: () => import('../views/productService/createProductService.vue'),
				meta: {
					title: '创建产品服务',
					type:4,
					keepAlive: true
				}
			},
			{
				path: 'productYZneed',
				component: () => import('../views/productService/productYZneed.vue'),
				meta: {
					title: '应助需求',
					type:4,
					keepAlive: true
				}
			},
			{
				path: 'YzNeedDraft',
				component: () => import('../views/productService/YzNeedDraft.vue'),
				meta: {
					title: '应助需求',
					type:4,
					keepAlive: true
				}
			},
			{
				path: 'editDraft',
				component: () => import('../views/productService/editDraft.vue'),
				meta: {
					title: '应助需求',
					type:4,
					keepAlive: true
				}
			}
		]
	},
	{
		path: '/geniusClub',
		component: () => import('../views/GeniusClub/geniusClub.vue'),
		meta: {
			title: '牛人俱乐部',
			type:5
		},
		children: [{
				path: '/',
				component: () => import('../views/GeniusClub/clubIndex.vue'),
				meta: {
					title: '牛人俱乐部',
					type:5
				},
			},
			{
				path: 'searchResult',
				component: () => import('../views/GeniusClub/searchResult.vue'),
				meta: {
					title: '牛人俱乐部搜索结果',
					type:5
				},
			},
			{
				path: 'searchResult',
				component: () => import('../views/GeniusClub/searchResult.vue'),
				meta: {
					title: '牛人俱乐部搜索结果',
					type:5
				},
			},
			{
				path: 'geniusInfo',
				component: () => import('../views/GeniusClub/geniusInfo.vue'),
				meta: {
					title: '牛人个人信息',
					noSearch: true,
					type:5
				},
			},
			{
				path: 'companyInfo',
				component: () => import('../views/GeniusClub/companyInfo.vue'),
				meta: {
					title: '公司信息',
					noSearch: true,
					type:5
				},
			}
		]
	},
	{
		path: '/userCenterShow',
		component: () => import('../views/userCenterShow/userCenter.vue'),
		meta: {
			nohead: true,
			title: '用户中心展示页'
		}
	},
	{
		path: '/userCenter',
		component: () => import('../views/userCenter/userCenter.vue'),
		meta: {
			title: '用户中心展示页'
		},
		children: [{
				path: '/',
				component: () => import('../views/userCenter/ucIndex.vue'),
				meta: {
					title: '用户中心首页'
				},
			},
			{
				path: 'drafts',
				component: () => import('../views/userCenter/drafts.vue'),
				meta: {
					title: '草稿箱'
				},
			},
			{
				path: 'banben',
				component: () => import('../views/userCenter/banben.vue'),
				meta: {
					title: '版本管理'
				},
			},
			{
				path: 'banbenselect',
				component: () => import('../views/userCenter/banbenselect.vue'),
				meta: {
					title: '选择版本'
				},
			},
			{
				path: 'Resume',
				component: () => import('../views/userCenter/Resume.vue'),
				meta: {
					title: '个人简历'
				},
			},
			{
				path: 'createCompany',
				component: () => import('../views/userCenter/createCompany.vue'),
				meta: {
					title: '创建企业'
				},
			},
			{
				path: 'updateCompany',
				component: () => import('../views/userCenter/updateCompany.vue'),
				meta: {
					title: '修改企业'
				},
			},
			{
				path: 'createTeam',
				component: () => import('../views/userCenter/createTeam.vue'),
				meta: {
					title: '创建小组'
				},
			},
			{
				path: 'Identification',
				component: () => import('../views/userCenter/Identification.vue'),
				meta: {
					title: '身份认证'
				},
			},
			{
				path: 'mySubscriptions',
				component: () => import('../views/userCenter/mySubscriptions.vue'),
				meta: {
					title: '我的订阅'
				},
			},
			{
				path: 'permissionSet',
				component: () => import('../views/userCenter/permissionSet.vue'),
				meta: {
					title: '我的订阅'
				},
			},
			{
				path: 'accountSet',
				component: () => import('../views/userCenter/accountSet.vue'),
				meta: {
					title: '我的订阅'
				},
			},
			
			{
				path: 'pthd',
				component: () => import('../views/userCenter/PTHD/index.vue'),
				meta: {
					title: '平台活动'
				},
				children: [{
						path: 'royalProperty',
						component: () => import('../views/userCenter/PTHD/royalProperty.vue'),
						meta: {
							title: '资产荣誉'
						}
					},
					{
						path: 'projectNeed',
						component: () => import('../views/userCenter/PTHD/projectNeed.vue'),
						meta: {
							title: '项目需求'
						}
					},
					{
						path: 'ktdw',
						component: () => import('../views/userCenter/PTHD/ktdw.vue'),
						meta: {
							title: '课题定位'
						}
					},
					
					{
						path: 'resourceTools',
						component: () => import('../views/userCenter/PTHD/resourceTools.vue'),
						meta: {
							title: '资源工具'
						}
					},
					{
						path: 'solution',
						component: () => import('../views/userCenter/PTHD/solution.vue'),
						meta: {
							title: '解决方案'
						}
					},
					{
						path: 'productService',
						component: () => import('../views/userCenter/PTHD/productService.vue'),
						meta: {
							title: '解决方案'
						}
					},
					{
						path: 'seekHelp',
						component: () => import('../views/userCenter/PTHD/seekHelp.vue'),
						meta: {
							title: '求助应助'
						}
					},
					{
						path: 'myUnion',
						component: () => import('../views/userCenter/PTHD/myUnion.vue'),
						meta: {
							title: '我的组织'
						}
					},
					{
						path: 'myTeam',
						component: () => import('../views/userCenter/PTHD/myTeam.vue'),
						meta: {
							title: '我的组织'
						}
					},
					{
						path: 'myMessage',
						component: () => import('../views/userCenter/PTHD/myMessage.vue'),
						meta: {
							title: '我的订阅'
						},
					}
				]
			}
		]
	},
	{
		path: '/companyCenter',
		component: () => import('../views/company/companyCenter.vue'),
		meta: {
			title: '公司管理页'
		},
		children: [{
				path: '/',
				component: () => import('../views/company/companyIndex.vue'),
				meta: {
					title: '公司管理首页'
				}
			},
			{
				path: 'drafts',
				component: () => import('../views/company/drafts.vue'),
				meta: {
					title: '公司草稿箱',
					noRight: true
				}
			},
			{
				path: 'companyProperty',
				component: () => import('../views/company/companyProperty.vue'),
				meta: {
					title: '公司财产',
				}
			},
			{
				path: 'ordeHistory',
				component: () => import('../views/company/ordeHistoryr.vue'),
				meta: {
					title: '历史订单',
				}
			},
			{
				path: 'backlog',
				component: () => import('../views/company/backlog.vue'),
				meta: {
					title: '进行中的订单',
				}
			},
			{
				path: 'projectNeed',
				component: () => import('../views/company/projectNeed.vue'),
				meta: {
					title: '项目需求',
				}
			},
			{
				path: 'resourceTools',
				component: () => import('../views/company/resourceTools.vue'),
				meta: {
					title: '资源工具',
				}
			},
			{
				path: 'solution',
				component: () => import('../views/company/solution.vue'),
				meta: {
					title: '解决方案',
				}
			},
			{
				path: 'productService',
				component: () => import('../views/company/productService.vue'),
				meta: {
					title: '解决方案',
				}
			},
			{
				path: 'seekHelp',
				component: () => import('../views/company/seekHelp.vue'),
				meta: {
					title: '解决方案',
				}
			},
			{
				path: 'accountSet',
				component: () => import('../views/company/accountSet.vue'),
				meta: {
					title: '账号设置',
					noRight: true
				}
			},
			{
				path: 'Department',
				component: () => import('../views/company/createDepartment.vue'),
				meta: {
					title: '部门管理',
				}
			},
			{
				path: 'position',
				component: () => import('../views/company/position.vue'),
				meta: {
					title: '岗位管理',
				}
			},
			{
				path: 'message',
				component: () => import('../views/company/message.vue'),
				meta: {
					title: '我的消息',
				}
			},
		]
	},
	{
		path: '/SmallGroup',
		component: () => import('../views/SmallGroup/companyCenter.vue'),
		meta: {
			title: '小组管理页'
		},
		children: [{
				path: '/',
				component: () => import('../views/SmallGroup/companyIndex.vue'),
				meta: {
					title: '小组管理首页'
				}
			},
			{
				path: 'drafts',
				component: () => import('../views/SmallGroup/drafts.vue'),
				meta: {
					title: '小组草稿箱',
					noRight: true
				}
			},
			{
				path: 'companyProperty',
				component: () => import('../views/SmallGroup/companyProperty.vue'),
				meta: {
					title: '小组财产',
				}
			},
			{
				path: 'ordeHistory',
				component: () => import('../views/SmallGroup/ordeHistoryr.vue'),
				meta: {
					title: '历史订单',
				}
			},
			{
				path: 'backlog',
				component: () => import('../views/SmallGroup/backlog.vue'),
				meta: {
					title: '进行中的订单',
				}
			},
			{
				path: 'projectNeed',
				component: () => import('../views/SmallGroup/projectNeed.vue'),
				meta: {
					title: '项目需求',
				}
			},
			{
				path: 'resourceTools',
				component: () => import('../views/SmallGroup/resourceTools.vue'),
				meta: {
					title: '资源工具',
				}
			},
			{
				path: 'solution',
				component: () => import('../views/SmallGroup/solution.vue'),
				meta: {
					title: '解决方案',
				}
			},
			{
				path: 'productService',
				component: () => import('../views/SmallGroup/productService.vue'),
				meta: {
					title: '解决方案',
				}
			},
			{
				path: 'seekHelp',
				component: () => import('../views/SmallGroup/seekHelp.vue'),
				meta: {
					title: '求助应助',
				}
			},
			{
				path: 'accountSet',
				component: () => import('../views/SmallGroup/accountSet.vue'),
				meta: {
					title: '小组账号设置',
					noRight: true
				}
			},
			{
				path: 'Department',
				component: () => import('../views/SmallGroup/createDepartment.vue'),
				meta: {
					title: '小组部门管理',
				}
			},
			{
				path: 'position',
				component: () => import('../views/SmallGroup/position.vue'),
				meta: {
					title: '小组岗位管理',
				}
			},
			{
				path: 'message',
				component: () => import('../views/SmallGroup/message.vue'),
				meta: {
					title: '我的消息',
				}
			},
		]
	}
]


const router = new VueRouter({
	routes
})
//页面跳转后页面置顶
router.afterEach((to,from,next) => {
	 if(to.meta.type === 1){
		store.commit('SET_HeadActive',1)
	 }else if(to.meta.type === 2){
		 store.commit('SET_HeadActive',2)
	 }else if(to.meta.type === 3){
		 store.commit('SET_HeadActive',3)
	 }else if(to.meta.type === 4){
		 store.commit('SET_HeadActive',4)
	 }else if(to.meta.type === 5){
		 store.commit('SET_HeadActive',5)
	 }else if(to.meta.type === 'keep'){
		 store.commit('SET_HeadActive',store.state.headActive)
	 }else{
		 store.commit('SET_HeadActive',0)
	 }
	 
      window.scrollTo(0,0);
 })


export default router